/**
 * ES2019 Object.fromEntries alternative for older browsers (e.g. Mobile Safari 12).
 * Use this instead of Object.fromEntries when targeting ES2018 or older.
 */
export function fromEntries<T>(
  entries: Array<readonly [string, T]> | Iterable<readonly [string, T]>,
): Record<string, T> {
  const list = Array.isArray(entries) ? entries : Array.from(entries)
  const result: Record<string, T> = {}
  for (let i = 0; i < list.length; i++) {
    const entry = list[i]
    if (entry != null && entry.length >= 2) {
      result[String(entry[0])] = entry[1] as T
    }
  }
  return result
}
